// src/services/clientService.ts
import api from './api';
import { Client, NewClient } from '../types';

export class ClientService {
  static async getClients(token: string): Promise<Client[]> {
    const response = await api.get<{ clients: any[] } | any[]>('/api/clients', token);
    const rawClients = Array.isArray(response) ? response : response.clients || [];
    
    // Transform backend fields to match frontend interface
    return rawClients.map((rawClient: any) => ({
      id: rawClient.id,
      name: rawClient.company_name || rawClient.name || '',
      email: rawClient.contact_email || rawClient.email || '',
      phone: rawClient.contact_phone || rawClient.phone,
      address: rawClient.address,
      status: rawClient.status || 'active',
      website: rawClient.website,
      industry: rawClient.industry,
      companySize: rawClient.company_size || rawClient.companySize,
      annualRevenue: rawClient.annual_revenue || rawClient.annualRevenue,
      timezone: rawClient.timezone,
      logoUrl: rawClient.logo_url || rawClient.logoUrl,
      billingContactId: rawClient.billing_contact_id || rawClient.billingContactId,
      accountManagerId: rawClient.account_manager_id || rawClient.accountManagerId,
      createdBy: rawClient.created_by || rawClient.createdBy,
      createdAt: rawClient.created_at || rawClient.createdAt || new Date().toISOString(),
      updatedAt: rawClient.updated_at || rawClient.updatedAt || new Date().toISOString(),
    }));
  }

  static async createClient(clientData: NewClient, token: string, userId: number): Promise<Client> {
    const backendData = {
      company_name: clientData.name,
      contact_email: clientData.email,
      contact_phone: clientData.phone,
      address: clientData.address,
      website: clientData.website,
      industry: clientData.industry,
      company_size: clientData.companySize,
      annual_revenue: clientData.annualRevenue,
      timezone: clientData.timezone,
      status: clientData.status === 'prospective' ? 'prospect' : clientData.status,
      created_by: userId,
      account_manager_id: userId
    };
    
    return api.post<Client>('/api/clients', backendData, token);
  }

  static async updateClient(id: number, clientData: Partial<NewClient>, token: string): Promise<Client> {
    const backendData = {
      company_name: clientData.name,
      contact_email: clientData.email,
      contact_phone: clientData.phone,
      address: clientData.address,
      website: clientData.website,
      industry: clientData.industry,
      company_size: clientData.companySize,
      annual_revenue: clientData.annualRevenue,
      timezone: clientData.timezone,
      status: clientData.status === 'prospective' ? 'prospect' : clientData.status
    };
    
    return api.put<Client>(`/api/clients/${id}`, backendData, token);
  }

  static async deleteClient(id: number, token: string): Promise<void> {
    return api.delete<void>(`/api/clients/${id}`, token);
  }
}